import { render, staticRenderFns } from "./display.vue?vue&type=template&id=d48cf82e&scoped=true&"
import script from "./display.vue?vue&type=script&lang=js&"
export * from "./display.vue?vue&type=script&lang=js&"
import style0 from "./display.vue?vue&type=style&index=0&id=d48cf82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48cf82e",
  null
  
)

export default component.exports